"use client";

import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import resultimg from "../assets/characters_v1.webp";
import api from "../sever/Api";

export default function JohariFeedback() {
  const { userId } = useParams();

  const adjectives = useMemo(
    () => [
      "Able", "Accepting", "Adaptable", "Adventurous", "Agreeable", "Angry", "Arrogant", "Artistic", "Attentive",
      "Balanced", "Bold", "Bossy", "Brave", "Calm", "Caring", "Careless", "Cheerful", "Clever", "Complex", "Confident",
      "Controlling", "Cooperative", "Cowardly", "Creative", "Cruel", "Curious", "Decisive", "Deceitful", "Dependable",
      "Dignified", "Dishonest", "Disrespectful", "Dynamic", "Egotistical", "Efficient", "Energetic", "Enthusiastic",
      "Extroverted", "Flexible", "Forgetful", "Friendly", "Funny", "Generous", "Gentle", "Giving", "Greedy", "Happy",
      "Handy", "Hardworking", "Helpful", "Honest", "Hopeful", "Humorous", "Idealistic", "Impatient", "Inconsiderate",
      "Indecisive", "Independent", "Ingenious", "Inflexible", "Intelligent", "Impulsive", "Introverted", "Jealous", "Kind",
      "Knowledgeable", "Know-it-all", "Lazy", "Logical", "Loving", "Loyal", "Mean", "Mature", "Modest", "Moody",
      "Motivated", "Narcissistic", "Neat", "Nervous", "Observant", "Optimistic", "Organized", "Patient", "Pessimistic",
      "Persistent", "Playful", "Polite", "Practical", "Powerful", "Proud", "Quiet", "Reflective", "Relaxed", "Reliable",
      "Religious", "Reserved", "Resourceful", "Respectful", "Responsible", "Responsive", "Revengeful", "Rude",
      "Searching", "Self-assertive", "Self-conscious", "Selfish", "Sensitive", "Sensible", "Sentimental", "Shy", "Silly",
      "Sincere", "Smart", "Spontaneous", "Spiteful", "Stubborn", "Supportive", "Sympathetic", "Tactful", "Tense",
      "Thoughtful", "Trustworthy", "Understanding", "Unreliable", "Untrustworthy", "Vindictive", "Warm", "Wise", "Witty"
    ],
    []
  );

  const [selectedAdjectives, setSelectedAdjectives] = useState([]);
  const [relationship, setRelationship] = useState("");
  const [anonymous, setAnonymous] = useState(true);
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const minSelection = 5;
  const maxSelection = 20;

  const toggleAdjective = (adjective) => {
    setSelectedAdjectives((prev) => {
      if (prev.includes(adjective)) {
        return prev.filter((a) => a !== adjective);
      } else if (prev.length < maxSelection) {
        return [...prev, adjective];
      }
      return prev;
    });
  };

  const onSubmit = async () => {
    if (!userId) {
      toast.error("Invalid feedback link");
      return;
    }
    if (selectedAdjectives.length < minSelection) {
      toast.error(`Please select at least ${minSelection} adjectives`);
      return;
    }
    
    try {
      const response = await api.post('/api/johari-feedback/submit', {
        userId,
        adjectives: selectedAdjectives,
        anonymous,
        name: anonymous ? "Anonymous" : (name?.trim() || "Anonymous"),
        relationship: relationship || ""
      });

      setSubmitted(true);
      toast.success("Thanks! Your feedback has been recorded.");
    } catch (error) {
      console.error('Error submitting feedback:', error);
      toast.error("Failed to submit feedback. Please try again.");
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-4">
        <div className="bg-white max-w-xl w-full p-6 rounded-lg border">
          <h1 className="text-2xl font-bold mb-2 text-center">Thank you for your feedback!</h1>
          <p className="text-center text-gray-600 mb-4">You can close this page now.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F9FAFB] p-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold">Provide Johari Feedback</h1>
          
        </div>
        <div>
          {/* <img
          style={{ width: '100%', height: 'auto', maxWidth: '500px', margin: '10px auto' }}
            src={resultimg}
            alt="Johari Window" /> */}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="md:col-span-1">
            <label className="block text-sm text-gray-700 mb-1">Relationship</label>
            <select
              value={relationship}
              onChange={(e) => setRelationship(e.target.value)}
              className="w-full border rounded px-3 py-2"
            >
              <option value="">Select relationship</option>
              <option>Friend</option>
              <option>Family</option>
              <option>Colleague</option>
              <option>Manager</option>
              <option>Classmate</option>
              <option>Other</option>
            </select>
          </div>
          <div className="md:col-span-1">
            <label className="block text-sm text-gray-700 mb-1">Your Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={anonymous}
              placeholder={anonymous ? "Anonymous" : "Enter your name"}
              className="w-full border rounded px-3 py-2 disabled:bg-gray-100"
            />
            <div className="flex items-center mt-2 gap-2">
              <label className="text-sm text-gray-700">Submit Anonymously</label>
              <input style={{ cursor: "pointer" }} type="checkbox" checked={anonymous} onChange={() => setAnonymous(!anonymous)} />
            </div>
          </div>
        </div>
<p className="text-gray-600 text-sm">Select between {minSelection} and {maxSelection} adjectives.</p>
        <div className="bg-white rounded-lg border p-4">
          
          <div className="flex flex-wrap gap-2 justify-center">
            
            {adjectives.map((adjective) => {
              const isSelected = selectedAdjectives.includes(adjective);
              const isDisabled = !isSelected && selectedAdjectives.length >= maxSelection;
              return (
                <button
                  key={adjective}
                  onClick={() => toggleAdjective(adjective)}
                  disabled={isDisabled}
                  className={`px-3 py-1 text-sm rounded border transition ${isSelected
                    ? "bg-blue-600 text-white border-blue-600 hover:bg-blue-700"
                    : "border-gray-300 text-gray-700 hover:bg-blue-50"
                    } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                  {adjective}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-4 text-center">
          <button
            onClick={onSubmit}
            className={`px-6 py-2 rounded text-white ${selectedAdjectives.length >= minSelection ? "bg-blue-600 hover:bg-blue-700" : "bg-blue-300"
              }`}
            disabled={selectedAdjectives.length < minSelection}
          >
            Submit Feedback ({selectedAdjectives.length} selected)
          </button>
        </div>
      </div>
    </div>
  );
}


